import React, { useState } from "react";
import { useParams } from "react-router-dom";
import "./TripBooking.css";

const TripBooking = () => {
  const { title } = useParams();
  const decodedTitle = decodeURIComponent(title);

  const [formData, setFormData] = useState({
    name: "",
    contact: "",
    pax: "1",
    date: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
      tripTitle: decodedTitle,
    };

    try {
      const response = await fetch("https://sheetdb.io/api/v1/9tgybopmfnmms", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ data: [payload] }),
      });
      if (response.ok) {
        setSubmitted(true);
        setFormData({
          name: "",
          contact: "",
          pax: "1",
          date: "",
        });
        setTimeout(() => setSubmitted(false), 4000);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <div className="trip-booking">
      <h1>Book Your Trip to {decodedTitle}</h1>
      <p className="subtitle">
        Fill the form below and our team will contact you shortly!
      </p>
      <form onSubmit={handleSubmit} className="booking-form">
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="tel"
          name="contact"
          placeholder="Contact Number"
          value={formData.contact}
          onChange={handleChange}
          required
        />
        <select
          name="pax"
          value={formData.pax}
          onChange={handleChange}
          required
        >
          {[...Array(20)].map((_, i) => (
            <option key={i + 1} value={i + 1}>
              {i + 1} Pax
            </option>
          ))}
        </select>
        <input
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
          required
        />
        <button type="submit">Submit Booking</button>
        {submitted && <p className="success">Thanks! We’ll reach out soon.</p>}
      </form>
    </div>
  );
};

export default TripBooking;
